import { baseDarkTheme } from '~base-theme';
import carouselTheme from './carouselTheme';
var carouselDarkTheme = {
  carousel: Object.assign({}, carouselTheme.carousel, {
    arrows: {
      backgroundColor: baseDarkTheme.base.grays.grayDark,
      color: {
        default: baseDarkTheme.base.grays.grayLightest,
        primary: baseDarkTheme.base.grays.grayLightest
      }
    },
    dots: {
      background: {
        default: baseDarkTheme.base.grays.grayDark
      },
      activeBackground: {
        default: baseDarkTheme.base.grays.grayLight
      },
      border: {
        primary: baseDarkTheme.base.colors.primary
      }
    }
  })
};
export default carouselDarkTheme;